import React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import styled from 'styled-components';

const BookingCouponSel = ({ children }) => (
  <GridStyled>
    <Header as="h3">식사날짜 기준</Header>
    {children}
  </GridStyled>
);

const GridStyled = styled(Grid)`
  &&&& {
    position: relative;
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
`;

export default BookingCouponSel;
